import CloverRounded from "./images/CloverRounded.image.svg";
import CloverBold from "./images/CloverBold.image.svg";
import ZigzagSquare from "./images/ZigzagSquare.image.svg";
import CloudBold from "./images/CloudBold.image.svg";
import WaveSquare from "./images/WaveSquare.image.svg";
import SquareBold from "./images/SquareBold.image.svg";
import BlobFusion from "./images/BlobFusion.image.svg";
import ButterflyBold from "./images/ButterflyBold.image.svg";
import CloudPebbled from "./images/CloudPebbled.image.svg";
import CloverSplit from "./images/CloverSplit.image.svg";
import SquareNotchLeft from "./images/SquareNotchLeft.image.svg";
import SquareNotchRight from "./images/SquareNotchRight.image.svg";
import SquareTiltedCut from "./images/SquareTiltedCut.image.svg";
import StarCutBold from "./images/StarCutBold.image.svg";
import ZigzagStacked from "./images/ZigzagStacked.image.svg";
import {
    BymoPageMediaMaskingSvgShape
} from "../../client-server-common/bymo-pages/bymo-page-media-masking-shape/bymo-page-media-masking-shape";

export function bymoPageMediaMaskingSvgShapeGetSvg(maskingShape: BymoPageMediaMaskingSvgShape) {
    switch (maskingShape) {
        case BymoPageMediaMaskingSvgShape.CloverRounded:
            return CloverRounded;
        case BymoPageMediaMaskingSvgShape.CloverBold:
            return CloverBold;
        case BymoPageMediaMaskingSvgShape.ZigzagSquare:
            return ZigzagSquare;
        case BymoPageMediaMaskingSvgShape.CloudBold:
            return CloudBold;
        case BymoPageMediaMaskingSvgShape.WaveSquare:
            return WaveSquare;
        case BymoPageMediaMaskingSvgShape.SquareBold:
            return SquareBold;
        case BymoPageMediaMaskingSvgShape.BlobFusion:
            return BlobFusion;
        case BymoPageMediaMaskingSvgShape.ButterflyBold:
            return ButterflyBold;
        case BymoPageMediaMaskingSvgShape.CloudPebbled:
            return CloudPebbled;
        case BymoPageMediaMaskingSvgShape.CloverSplit:
            return CloverSplit;
        case BymoPageMediaMaskingSvgShape.SquareNotchLeft:
            return SquareNotchLeft;
        case BymoPageMediaMaskingSvgShape.SquareNotchRight:
            return SquareNotchRight;
        case BymoPageMediaMaskingSvgShape.SquareTiltedCut:
            return SquareTiltedCut;
        case BymoPageMediaMaskingSvgShape.StarCutBold:
            return StarCutBold;
        case BymoPageMediaMaskingSvgShape.ZigzagStacked:
            return ZigzagStacked;
    }
}

export function bymoPageMediaMaskingSvgShapeGetCssImageUrl(maskingShape: BymoPageMediaMaskingSvgShape) {
    const imageUrl = bymoPageMediaMaskingSvgShapeGetSvg(maskingShape);

    return `url(${imageUrl})`;
}